import { c as _c } from "react/compiler-runtime";
import { IcoTrash16 } from '@onefootprint/icons';
import type { ApiNodeData, GraphOperationRemoveNode } from '@onefootprint/request-types/dashboard';
import { Dropdown, useConfirmationDialog } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useEdit from '@/playbook-builder/hooks/use-edit';
import useSidebar from '../../hooks/use-sidebar';
import useStore from '../../hooks/use-store';
import { useGetStaticNodeInfo } from '../base-node/hooks/use-get-static-node-info';
type DeleteItemProps = {
  data: ApiNodeData;
  operation: GraphOperationRemoveNode;
  onClick: () => void;
};
const DeleteItem = t0 => {
  const $ = _c(23);
  const {
    data,
    operation,
    onClick
  } = t0;
  const confirm = useConfirmationDialog();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "removeNode"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const mutation = useEdit();
  const {
    isOpen,
    close: closeSidebar
  } = useSidebar();
  const {
    setNodeHighlight
  } = useStore();
  const getNodeInfo = useGetStaticNodeInfo();
  let t2;
  if ($[1] !== closeSidebar || $[2] !== confirm || $[3] !== data.kind || $[4] !== getNodeInfo || $[5] !== isOpen || $[6] !== mutation || $[7] !== onClick || $[8] !== operation || $[9] !== t) {
    t2 = async () => {
      onClick();
      const nodeKind = getNodeInfo(data.kind).title.lowercase;
      const title = t(_temp, {
        nodeKind,
        treeKind: operation.nodeIdsToDelete.length > 1 ? t(_temp2) : t(_temp3)
      });
      confirm.open({
        title,
        description: t(_temp4, {
          nodeKind,
          subtree: operation.nodeIdsToDelete.length > 1 ? t(_temp5) : ""
        }),
        variant: "destructive",
        primaryButton: {
          label: t(_temp6),
          onClick: async () => {
            await mutation.mutateAsync(operation);
            if (isOpen(operation.nodeIdsToDelete[0])) {
              closeSidebar();
            }
          }
        },
        secondaryButton: {
          label: t(_temp7)
        }
      });
    };
    $[1] = closeSidebar;
    $[2] = confirm;
    $[3] = data.kind;
    $[4] = getNodeInfo;
    $[5] = isOpen;
    $[6] = mutation;
    $[7] = onClick;
    $[8] = operation;
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  const handleDelete = t2;
  let t3;
  if ($[11] !== operation.nodeIdsToDelete || $[12] !== setNodeHighlight) {
    t3 = () => setNodeHighlight({
      color: "error",
      ids: operation.nodeIdsToDelete
    });
    $[11] = operation.nodeIdsToDelete;
    $[12] = setNodeHighlight;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== setNodeHighlight) {
    t4 = () => setNodeHighlight(undefined);
    $[14] = setNodeHighlight;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t) {
    t5 = t(_temp8);
    $[16] = t;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== handleDelete || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <Dropdown.Item iconLeft={IcoTrash16} destructive={true} onSelect={handleDelete} onMouseEnter={t3} onMouseLeave={t4}>{t5}</Dropdown.Item>;
    $[18] = handleDelete;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
export default DeleteItem;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.subtree;
}
function _temp3($_1) {
  return $_1.node;
}
function _temp4($_2) {
  return $_2.description;
}
function _temp5($_3) {
  return $_3.andItsSubtree;
}
function _temp6($_4) {
  return $_4.cta;
}
function _temp7($_5) {
  return $_5.cancel;
}
function _temp8($_6) {
  return $_6.label;
}